import { BASE_BORDER_RADIUS } from 'styles/Base';
import { CLOUD, GRAY, NAVY, SHADOWS, SKY, TERTIARY_TEXT } from 'styles/Colors';
import { LargeMobile } from 'styles/MediaQueries';
import { makeStyles } from '@mui/styles';
import { printPage } from 'helpers/Print';
import Box from '@mui/material/Box';
import CtaButton from '@opploans/cta-button-component/CtaButton';
import Modal from '@mui/material/Modal';
import Print from 'images/Print.svg';
import React from 'react';

const containerStyle = {
  borderStyle: 'solid',
  borderWidth: '1px',
  borderColor: NAVY,
  borderRadius: BASE_BORDER_RADIUS,
  height: '100%',
  marginTop: '1.75rem'
};

const headerStyle = {
  padding: '1rem',
  boxShadow: `0 4px 8px ${SHADOWS}`,
  display: 'flex',
  justifyContent: 'space-between',
  p: {
    fontFamily: 'Arimo',
    fontWeight: 'bold',
    fontSize: '20px',
    lineHeight: '24px',
    color: SKY
  },
  fontFamily: 'Arimo',
  fontSize: '14px'
};

const buttonStyle = {
  backgroundColor: CLOUD,
  color: SKY,
  border: `1px solid ${GRAY}`,
  fontSize: '16px',
  width: 'calc(100% - 1rem)',
  margin: '0.5rem',
  '&:active, &:hover': {
    backgroundColor: `${GRAY}!important`
  }
};

const printButtonStyle = {
  fontWeight: 'bold',
  fontSize: '1.25rem',
  display: 'inline-flex',
  lineHeight: '1.25rem',
  cursor: 'pointer',
  background: 'none',
  border: 'none'
};

const printIconStyle = {
  height: '3.25rem'
};

const style = {
  position: 'relative',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80vw',
  bgcolor: 'background.paper',
  [LargeMobile]: {
    height: '80%',
    width: '90vw'
  },
  boxShadow: 24,
  padding: 0,
  border: 'none',
  borderRadius: BASE_BORDER_RADIUS,
  p: 4
};

const useStyles = makeStyles({
  root: {
    padding: '0 !important'
  }
});
export default function BasicModal({
  open,
  handleClose,
  children,
  headerText,
  printId
}) {
  const scrollableAreaStyle = {
    '> *': {
      width: '100%',
      height: '64vh'
    },
    overflowY: 'scroll',
    fontSize: '12px',
    color: TERTIARY_TEXT
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box sx={style} className={useStyles().root}>
          <div css={[containerStyle]}>
            <div css={headerStyle}>
              <div>
                <p>{headerText}</p>
              </div>
              <button
                css={printButtonStyle}
                type='button'
                onClick={() => printPage(printId, headerText)}
              >
                <Print title='print' css={printIconStyle} />
              </button>
            </div>
            <div css={[scrollableAreaStyle]} data-testid='scrollableArea'>
              {children}
            </div>
            <CtaButton additionalStyle={buttonStyle} onClick={handleClose}>
              Close
            </CtaButton>
          </div>
        </Box>
      </Modal>
    </div>
  );
}
